import React, { useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import localeFr from "antd/es/date-picker/locale/fr_FR";
import calendarInput from "../../assets/img/CALENDRIER.svg";
import { formatDateString } from "../../utilities/filters";
import "./index.scss";
const CustomDatePicker = ({
  setFieldValue,
  handleBlur,
  onFocus,
  label,
  name,
  isTreso,
  values,
  style,
  errors,
  touched,
  labelNotice,
  disabled,
  shouldBeHalfSize,
}) => {
  const error = errors[name];
  const [panelMode, setPanelMode] = useState("date");

  const touch = touched[name];

  const formatToUse = isTreso
    ? ["MM/YYYY", "MM.YYYY", "MM-YYYY"]
    : ["DD/MM/YYYY", "DD.MM.YYYY", "DD-MM-YYYY"];

  return (
    <div className={`wrapper-select ${shouldBeHalfSize ? "half-size" : ""}`}>
      <>
        <div className="label-wrapper">
          <label htmlFor={label} className="input-text">
            {label}
          </label>
          {labelNotice && <div className="label-notice">{labelNotice}</div>}
        </div>
        <DatePicker
          style={style}
          allowClear={false}
          id={name}
          showNow={false}
          mode={panelMode}
          name={name}
          defaultValue={values ? dayjs(values) : null}
          onFocus={onFocus}
          disabled={disabled}
          superNextIcon={null}
          superPrevIcon={null}
          format={formatToUse}
          value={values ? dayjs(values) : null}
          placeholder="Choisir une date"
          locale={localeFr}
          className={
            values
              ? "form-element-input small"
              : "form-element-input calendar not-filled"
          }
          onBlur={handleBlur}
          dropdownClassName="custom-datepicker-dropdown"
          suffixIcon={<img src={calendarInput} alt="CalendarIcon" />}
          size="large"
          onChange={(dateString) => {
            setFieldValue(name, formatDateString(dateString));
          }}
          onPanelChange={(value, mode) => {
            setPanelMode("date");
          }}
        />
        {error && touch ? (
          <div className="error-displayer-form-modal">{error}</div>
        ) : null}
      </>
    </div>
  );
};

export default CustomDatePicker;
